module.exports = __webpack_public_path__ + "static/media/background_sample_02.c299f9a2.png";